import styled from 'styled-components';
import { color } from 'styles/colors';

export const container = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  > img {
    width: 100%;
    object-fit: fill;
    border-radius: 10px;
  }

  > p {
    font-size: 1.2rem;
    color: ${color.interface.darkgray};
    text-align: center;
  }
`;
